import React from "react";

export default function Divider({
  width,
  text,
  extraClass = "",
  HrExtraClass = "",
}) {
  return (
    <div
      className={`col text-center ${width ? width : "w-full"} ${extraClass}`}
    >
      <div className="relative">
        <hr
          className={`absolute w-full border-gray-100 border-100 ${HrExtraClass}`}
          style={{ marginTop: "12px" }}
        />
      </div>
      {text && (
        <span className="bg-white relative z-3 px-3 text-gray-400">{text}</span>
      )}
    </div>
  );
}

export function SingleDivider({ borderColor = 'border-gray-300', borderWidth = 'border-1.5', extraClass = '' })
 {
  return (
    <div
      className={`w-full ${borderColor} ${borderWidth} ${extraClass}`}
      style={{ borderTopStyle: 'solid', margin: '1rem 0' }}
    ></div>
  );
}

